var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shown,
      expression: "shown"
    }],
    staticClass: "s-notification"
  }, [_c('Info', {
    staticClass: "s-text-secondary s-mr-1"
  }), _vm._v(" 您的數位會員卡尚未完成歸戶，請至 "), _c('a', {
    staticClass: "s-link s-link-secondary",
    attrs: {
      "href": "https://lihi1.com/ZDdSf/LINE",
      "target": "_blank"
    }
  }, [_vm._v("POYA Pay")]), _vm._v(" 歸戶以查詢完整點數資訊。 "), _c('button', {
    staticClass: "s-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✕")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }